import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useReactiveVar } from '@apollo/client'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { format, intlFormat } from 'date-fns'
import { Analytics } from 'shared-components'
import { TimezoneBlock } from 'shared-components'
import { Subheader } from 'shared-components'

import { BookingForm } from '../../components/Forms'

import {
  appointmentDateTime,
  providerNameVar,
  store,
  timezoneAbbr,
} from '../../cache'
import i18next from '../../i18n'

export const BookAppointment = () => {
  // Appointment Details
  const datetime = useReactiveVar(appointmentDateTime)
  const provider = useReactiveVar(providerNameVar)

  // Localization and Translations
  const { t } = useTranslation()
  const langCode = i18next.language

  const dayOfWeek = intlFormat(
    datetime,
    { weekday: 'long' },
    { locale: langCode }
  ).toUpperCase()

  const formattedDateTime = intlFormat(
    datetime,
    {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    },
    { locale: langCode }
  ).toUpperCase()

  // Track Analytics
  const { locationId, partnerId } = useReactiveVar(store)

  useEffect(() => {
    Analytics.bookingStarted({
      dayOfWeek: format(datetime, 'EEEE').toUpperCase(),
      locationId,
      partnerId,
      time: format(datetime, 'HH:mm'),
    })
  }, [dayOfWeek, datetime, locationId, partnerId])

  return (
    <Grid container aria-label="book-appointment-container">
      <Grid
        item
        container
        aria-label="book-appointment-body"
        flexDirection="column"
        pt={4}
        pb={5}
        gap={5}
      >
        <Grid
          item
          container
          aria-label="datetime-section"
          alignItems="center"
          flexDirection="column"
          gap={2}
          width="100%"
        >
          <Grid item container flexDirection="column" alignContent="center">
            <Typography align="center" variant="h5" color="secondary">
              {dayOfWeek}
              <br />
              {formattedDateTime}
            </Typography>
            <Typography
              align="center"
              variant="h6"
              color="secondary"
              sx={{ fontWeight: 500 }}
            >
              {provider}
            </Typography>
          </Grid>
          <Grid item>
            <TimezoneBlock store={store} timezoneAbbr={timezoneAbbr} />
          </Grid>
        </Grid>
        <Grid
          item
          container
          aria-label="patient-form-section"
          alignItems="center"
          flexDirection="column"
          gap={1}
        >
          <Subheader text={t('Patient Information')} />
          <BookingForm />
        </Grid>
      </Grid>
    </Grid>
  )
}
